// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1DUFg","buttons":"PendingPaymentAlert_buttons__3OTa9"};